export default {
  getAllowedDDDs: (state) => {
    return state.ddd.filter(ddd => !state.blacklistedDDDs.includes(ddd.value));
  },
};
